export const config = {
  api: process.env.REACT_APP_API,
  apiImage: `${process.env.REACT_APP_API}/storage/`,
  domain: process.env.REACT_APP_DOMAIN,
  env: process.env.NODE_ENV,
  sentry: process.env.REACT_APP_SENTRY,
};
